import createAction         from '../redux-utils/create-action'
import { ToastMeta }        from '../sagas/toast.saga'
import { Reducer }          from '../types'
import { ApplicationState } from './index'

const NAMESPACE = 'toast'

export const ACTIVATE = `[${NAMESPACE}] ACTIVATE`
export const DISMISS = `[${NAMESPACE}] DISMISS`
export const CHANGE = `[${NAMESPACE}] CHANGE`

/* REDUCERS */

export interface ToastState {
  isDisplayed: boolean
  hasLoader: boolean
  values: any
  message: string
  error: boolean
  i18nPrefix: string
  withoutI18nPrefix: boolean
}

const initial: ToastState = {
  isDisplayed:       false,
  hasLoader:         false,
  values:            {},
  message:           '',
  error:             false,
  i18nPrefix:        '',
  withoutI18nPrefix: false,
}

const toast: Reducer<ToastState> = (state = initial, { type, payload }) => {
  switch (type) {
    case ACTIVATE:
      return {
        ...state,
        isDisplayed: true,
      }

    case DISMISS:
      return {
        ...state,
        isDisplayed: false,
      }

    case CHANGE:
      return {
        ...state,
        ...payload,
      }

    default:
      return state
  }
}

/* ROOT-REDUCER EXPORT */

export default toast

/* ACTION CREATORS */

export const changeToast = (payload: {
  message?: ToastState['message'],
  hasLoader?: ToastState['hasLoader'],
  values?: ToastState['values'],
  error?: ToastState['error'],
  i18Code?: ToastState['i18nPrefix'],
  withoutI18nPrefix?: ToastState['withoutI18nPrefix'],
}) =>
  createAction(CHANGE, payload)

export const activateToast = () =>
  createAction(ACTIVATE)

export const dismissToast = () =>
  createAction(DISMISS)

export const queueToast = (toastMeta: ToastMeta) =>
  createAction(
    'QUEUE_TOAST',
    null,
    { toast: toastMeta },
  )

/* SELECTORS */

export const getToastState = (state: ApplicationState) =>
  state.toast



// WEBPACK FOOTER //
// ./src/redux/ducks/toast.duck.ts